import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton, SHOPIFY_URL } from './ui/CTAButton';
import { ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="py-20 px-4 bg-white scroll-mt-20" data-id="element-173">
      <div className="max-w-4xl mx-auto text-center" data-id="element-174">
        <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6" data-id="element-175">
          💳 Oferta por tiempo limitado
        </h2>

        <p className="text-xl md:text-2xl font-bold text-gray-700 mb-12" data-id="element-176">
          Accedé al MEGA KIT LECTOESCRITURA + todos los bonos + regalos de HOY
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-yellow-50 to-white p-8 md:p-12 rounded-3xl shadow-2xl border-4 border-yellow-400 relative" data-id="element-177">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-red-600 text-white font-black px-6 py-2 rounded-full text-lg shadow-lg whitespace-nowrap" data-id="element-178">
            ¡OFERTA ESPECIAL!
          </div>

          <div className="mb-8 mt-4" data-id="element-179">
            <p className="text-2xl text-gray-500 font-bold mb-2" data-id="element-180">
              Precio regular: <span className="line-through" data-id="element-181">$49.999 ARS</span>
            </p>
            <div className="flex flex-col items-center justify-center" data-id="element-182">
              <span className="text-lg font-bold text-red-600 mb-1" data-id="element-183">
                🔥 HOY SOLO:
              </span>
              <span className="text-7xl md:text-8xl font-black text-gray-900 tracking-tighter" data-id="element-184">
                $19.990 ARS
              </span>
              <span className="text-sm font-bold text-gray-500 mt-2 bg-gray-100 px-3 py-1 rounded-full" data-id="element-185">
                (Precio en pesos argentinos)
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 max-w-lg mx-auto mb-8 text-left" data-id="element-186">
            <div className="flex items-center gap-2 font-bold text-gray-700" data-id="element-187">
              <span className="text-green-500" data-id="element-188">✔</span> Acceso inmediato
            </div>
            <div className="flex items-center gap-2 font-bold text-gray-700" data-id="element-189">
              <span className="text-green-500" data-id="element-190">✔</span> Un solo pago
            </div>
            <div className="flex items-center gap-2 font-bold text-gray-700" data-id="element-191">
              <span className="text-green-500" data-id="element-192">✔</span> Descarga digital (PDF)
            </div>
            <div className="flex items-center gap-2 font-bold text-gray-700" data-id="element-193">
              <span className="text-green-500" data-id="element-194">✔</span> Acceso de por vida
            </div>
          </div>

          <div className="mb-5 inline-block" data-id="element-195">
            <p className="text-sm font-bold text-gray-800" data-id="element-196">
              💳 Podés pagar en hasta 3 cuotas
            </p>
          </div>

          <CTAButton text="👉 OBTENER MI MEGA KIT HOY" className="max-w-xl mx-auto" href={SHOPIFY_URL} data-id="element-197" />

          <div className="mt-4 flex items-center justify-center gap-1.5 bg-sky-50 border border-sky-200 rounded-full py-2 px-4 mx-auto max-w-sm" data-id="element-198">
            <ShieldCheck className="w-4 h-4 text-sky-600 flex-shrink-0" data-id="element-199" />
            <span className="font-semibold text-sky-700 text-xs" data-id="element-200">
              Pago 100% respaldado por Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}